import MajorList from "./StatisticalPageSlider";
import ReviewIcon from "@material-ui/icons/PostAddOutlined";

export default {
  icon: ReviewIcon,
  list: MajorList,
  name: "statisticalslider",
};
